module.exports = __webpack_public_path__ + "img/person-plug.868879d3.png";